export default {
  label: '高级程序员',
  id: '0',
  children: [
    {
      label: '定义',
      id: '0-1',
      children: [
        {
          label: '技术团队的核心，负责复杂系统开发。',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '职责',
      id: '0-2',
      children: [
        {
          label: '负责核心代码编程，解决技术难点，设计独立业务模块和数据库表，优化性能。',
          id: '0-2-1',
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备深厚的专业知识，能够领导团队完成大型项目，熟悉系统架构设计和性能优化。',
          id: '0-3-1',
        },
      ],
    },
    {
      label: '职业发展',
      id: '0-4',
      children: [
        {
          label: '通常在5-7年后晋升为技术专家或架构师。',
          id: '0-4-1',
        },
      ],
    },
    {
      label: '薪资水平',
      id: '0-5',
      children: [
        {
          label: '月薪在15,000元至30,000元之间。',
          id: '0-5-1',
        },
      ],
    },
  ],
};